/* Търсачка по автомобил – обща логика за sections/vehicle-finder и sections/vehicle-bar.
   Филтрира по един таг на поколение (car-*) чрез вградения адрес /collections/<колекция>/<таг>. */
(function () {
  if (window.VehicleFinder) return;

  var STORE_KEY = 'vehicleFinder:selection';
  var dataCache = {};

  function store(sel) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(sel)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('vf:change', { detail: sel }));
  }
  function stored() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function forget() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    document.dispatchEvent(new CustomEvent('vf:change', { detail: null }));
  }
  function genLabel(l) { return String(l).replace(/-\)$/, '+)'); }

  // Remove the chosen vehicle everywhere; on a page filtered by a vehicle, go back to the unfiltered list.
  function clearVehicle() {
    forget();
    track('vehicle_cleared', { page_type: location.pathname.split('/')[1] || 'home' });
    var route = routeOf(location.pathname);
    if (route && route.tag && route.tag.indexOf('car-') === 0) {
      var url = new URL(location.href);
      url.searchParams.delete('page');
      location.href = route.prefix + url.search;
      return true;
    }
    return false;
  }

  // Analytics: Google (gtag / GTM dataLayer) and Shopify Customer events (custom pixels).
  function track(name, params) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, params);
    } catch (e) {}
  }
  function trackParams(v, extra) {
    return Object.assign({
      vehicle: vehicleText(v), vehicle_make: v.make, vehicle_model: v.model, vehicle_generation: genLabel(v.gen),
      vehicle_tag: v.tag, page_type: location.pathname.split('/')[1] || 'home'
    }, extra || {});
  }
  function vehicleText(v) { return v.make + ' ' + v.model + ' ' + genLabel(v.gen); }
  function loadData(url) {
    if (!dataCache[url]) dataCache[url] = fetch(url).then(function (r) { return r.json(); });
    return dataCache[url];
  }

  // /collections/<handle>/<tag> works in every collection (including "all") and needs no storefront filter.
  // Products that fit a whole model/make carry every generation tag they fit, so one generation tag is enough.
  function routeOf(path) {
    var parts = path.split('/').filter(Boolean);
    var i = parts.indexOf('collections');
    return i < 0 ? null : { prefix: '/' + parts.slice(0, i + 2).join('/'), tag: parts[i + 2] ? decodeURIComponent(parts[i + 2]) : '' };
  }
  function filteredUrl(baseUrl, tag) {
    var url = new URL(baseUrl, location.origin);
    var route = routeOf(url.pathname);
    url.searchParams.delete('page');
    url.searchParams.delete('filter.p.tag');
    return (route ? route.prefix : url.pathname) + '/' + encodeURIComponent(tag) + url.search;
  }
  function findSaved(data, sel) {
    if (!sel) return null;
    var mk = data.find(function (m) { return m.n === sel.make; });
    var md = mk && mk.m.find(function (m) { return m.n === sel.model; });
    var g = md && md.g.find(function (x) { return x.l === sel.gen; });
    return g ? { make: mk.n, model: md.n, gen: g.l, tag: g.t } : null;
  }
  function findByTag(data, tag) {
    for (var i = 0; i < data.length; i++)
      for (var j = 0; j < data[i].m.length; j++)
        for (var k = 0; k < data[i].m[j].g.length; k++)
          if (data[i].m[j].g[k].t === tag) return { make: data[i].n, model: data[i].m[j].n, gen: data[i].m[j].g[k].l, tag: tag };
    return null;
  }

  function init(root) {
    if (!root || root.dataset.vfReady) return;
    root.dataset.vfReady = '1';

    var mode = root.dataset.mode;
    var label = root.dataset.productLabel || 'продукти';
    var makeSel = root.querySelector('[data-vf-make]');
    var modelSel = root.querySelector('[data-vf-model]');
    var genSel = root.querySelector('[data-vf-gen]');
    var submit = root.querySelector('[data-vf-submit]');
    var summary = root.querySelector('[data-vf-summary]');
    var data = [];
    var fullData = [];

    // Links offered when a vehicle has no products here: all categories for the vehicle + contact.
    function emptyHelp(v) {
      var box = document.createElement('span');
      box.className = 'vf__help';
      var cat = root.dataset.categoriesUrl;
      var opener = document.querySelector('[data-vf-open]');
      if (cat) {
        var a = document.createElement('a');
        a.href = cat; a.className = 'vf__help-link'; a.textContent = 'Вижте всички категории за ' + v.model;
        box.appendChild(a);
      } else if (opener && !root.closest('dialog')) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'vf__help-link'; b.textContent = 'Вижте всички категории за ' + v.model;
        b.addEventListener('click', function () { opener.click(); });
        box.appendChild(b);
      }
      var c = document.createElement('a');
      c.href = root.dataset.contactUrl || '/pages/contact'; c.className = 'vf__help-link vf__help-link--ghost'; c.textContent = 'Не намирате? Пишете ни';
      box.appendChild(c);
      return box;
    }
    // Collection pages list the vehicles that have products here; limit the dropdowns to them.
    function availableTags() {
      var s = root.querySelector('script[data-vf-available]');
      if (!s) return null;
      if (parseInt(root.dataset.allTagsCount || '0', 10) >= 1000) return null; // Shopify caps all_tags at 1000
      try {
        var list = JSON.parse(s.textContent).filter(Boolean);
        return list.length ? new Set(list) : null;
      } catch (e) { return null; }
    }
    function restrict(json, avail) {
      if (!avail) return json;
      return json.map(function (mk) {
        var models = mk.m.map(function (md) {
          var g = md.g.filter(function (x) { return avail.has(x.t); });
          return g.length ? { n: md.n, t: md.t, g: g } : null;
        }).filter(Boolean);
        return models.length ? { n: mk.n, t: mk.t, m: models } : null;
      }).filter(Boolean);
    }

    function fill(select, items, placeholder) {
      select.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      select.appendChild(o);
      items.forEach(function (it, i) {
        var opt = document.createElement('option');
        opt.value = String(i); opt.textContent = it;
        select.appendChild(opt);
      });
      select.disabled = items.length === 0;
    }
    function current() {
      var mk = data[makeSel.value], md = mk && mk.m[modelSel.value], g = md && md.g[genSel.value];
      return g ? { make: mk.n, model: md.n, gen: g.l, tag: g.t } : null;
    }
    function onMake() {
      var mk = data[makeSel.value];
      fill(modelSel, mk ? mk.m.map(function (m) { return m.n; }) : [], mk ? 'Изберете модел' : 'Първо изберете марка');
      fill(genSel, [], 'Първо изберете модел');
      submit.disabled = true;
    }
    function onModel() {
      var mk = data[makeSel.value], md = mk && mk.m[modelSel.value];
      fill(genSel, md ? md.g.map(function (g) { return genLabel(g.l); }) : [], md ? 'Изберете поколение' : 'Първо изберете модел');
      if (md && md.g.length === 1) genSel.value = '0';
      submit.disabled = !current();
    }
    function select(v) {
      var mi = data.findIndex(function (m) { return m.n === v.make; });
      if (mi < 0) return false;
      makeSel.value = String(mi); onMake();
      var di = data[mi].m.findIndex(function (m) { return m.n === v.model; });
      if (di < 0) return false;
      modelSel.value = String(di); onModel();
      var gi = data[mi].m[di].g.findIndex(function (g) { return g.l === v.gen; });
      if (gi < 0) return false;
      genSel.value = String(gi); submit.disabled = false;
      return true;
    }
    function hideResults() { var r = root.querySelector('[data-vf-results]'); if (r) r.hidden = true; }
    function resetForm() { makeSel.value = ''; onMake(); summary.hidden = true; hideResults(); }
    function showSummary(html, withClear) {
      summary.innerHTML = '<span>' + html + '</span>';
      if (withClear) {
        var actions = document.createElement('span');
        actions.className = 'vf__actions';
        var change = document.createElement('button');
        change.type = 'button'; change.className = 'vf__clear'; change.textContent = 'Смени автомобила';
        change.addEventListener('click', function () { resetForm(); makeSel.focus(); });
        var all = document.createElement('button');
        all.type = 'button'; all.className = 'vf__all'; all.textContent = '✕ Покажи всички продукти';
        all.addEventListener('click', function () { if (!clearVehicle()) { resetForm(); makeSel.focus(); } });
        actions.appendChild(change);
        actions.appendChild(all);
        summary.appendChild(actions);
      }
      summary.hidden = false;
    }
    // another finder or the bar removed the vehicle
    document.addEventListener('vf:change', function (e) { if (!e.detail && data.length) resetForm(); });

    // ---- categories: selected collections, one count request per collection
    function countIn(url, v) {
      var u = filteredUrl(url, v.tag);
      u += (u.indexOf('?') < 0 ? '?' : '&') + 'section_id=vehicle-count';
      return fetch(u, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var m = html.replace(/<[^>]*>/g, ' ').match(/\d+/); return m ? parseInt(m[0], 10) : 0; })
        .catch(function () { return 0; });
    }
    function runSelected(v) {
      var results = root.querySelector('[data-vf-results]');
      var grid = root.querySelector('[data-vf-grid]');
      var status = root.querySelector('[data-vf-status]');
      var tpl = root.querySelector('template[data-vf-collections]');
      if (!results || !tpl) return;
      results.hidden = false;
      grid.innerHTML = '';
      var cards = Array.prototype.slice.call(tpl.content.cloneNode(true).querySelectorAll('.vf__card'));
      if (!cards.length) { status.textContent = 'Не са избрани категории в настройките на секцията.'; return; }
      status.textContent = 'Търсим ' + label + ' за ' + vehicleText(v) + '…';
      cards.forEach(function (c) { grid.appendChild(c); });
      var queue = cards.slice(), found = 0, active = 0;
      function next() {
        if (!queue.length && !active) {
          finishCategories(status, v, found);
          return;
        }
        while (active < 6 && queue.length) {
          (function (card) {
            active++;
            countIn(card.dataset.url, v).then(function (n) {
              active--;
              if (n > 0) {
                found++;
                card.querySelector('[data-vf-count]').textContent = n + (n === 1 ? ' продукт' : ' продукта');
                card.querySelector('a').href = filteredUrl(card.dataset.url, v.tag);
                card.hidden = false;
              } else { card.remove(); }
              next();
            });
          })(queue.shift());
        }
      }
      next();
    }

    // ---- categories: all collections – list the tagged products page by page and group them by collection
    function fetchPage(tag, page) {
      var u = '/collections/all/' + encodeURIComponent(tag) + '?section_id=vehicle-collections&page=' + page;
      return fetch(u, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var box = document.createElement('div');
          box.innerHTML = html;
          var s = box.querySelector('script[data-vf-page]');
          return s ? JSON.parse(s.textContent) : { pages: 0, items: [] };
        })
        .catch(function () { return { pages: 0, items: [] }; });
    }
    function runAll(v) {
      var results = root.querySelector('[data-vf-results]');
      var grid = root.querySelector('[data-vf-grid]');
      var status = root.querySelector('[data-vf-status]');
      if (!results) return;
      var exclude = (root.dataset.exclude || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      results.hidden = false;
      grid.innerHTML = '';
      status.textContent = 'Търсим ' + label + ' за ' + vehicleText(v) + '…';
      var cols = {};
      function collect(page) {
        page.items.forEach(function (list) {
          list.forEach(function (c) {
            if (exclude.indexOf(c.h.toLowerCase()) >= 0) return;
            if (!cols[c.h]) cols[c.h] = { c: c, n: 0 };
            cols[c.h].n++;
          });
        });
      }
      fetchPage(v.tag, 1).then(function (first) {
        collect(first);
        var rest = [];
        for (var p = 2; p <= Math.min(first.pages, 20); p++) rest.push(fetchPage(v.tag, p));
        return Promise.all(rest);
      }).then(function (pages) {
        pages.forEach(collect);
        var list = Object.keys(cols).map(function (h) { return cols[h]; })
          .sort(function (a, b) { return b.n - a.n || a.c.t.localeCompare(b.c.t, 'bg'); });
        finishCategories(status, v, list.length, list.reduce(function (s, e) { return s + e.n; }, 0));
        list.forEach(function (e) {
          var li = document.createElement('li');
          li.className = 'vf__card';
          var a = document.createElement('a');
          a.className = 'vf__card-link';
          a.href = filteredUrl(e.c.u, v.tag);
          if (e.c.i) {
            var img = document.createElement('img');
            img.className = 'vf__card-img'; img.loading = 'lazy'; img.alt = e.c.t; img.src = e.c.i;
            a.appendChild(img);
          }
          var t = document.createElement('span'); t.className = 'vf__card-title'; t.textContent = e.c.t; a.appendChild(t);
          var n = document.createElement('span'); n.className = 'vf__card-count'; n.textContent = e.n + (e.n === 1 ? ' продукт' : ' продукта'); a.appendChild(n);
          li.appendChild(a);
          grid.appendChild(li);
        });
      });
    }
    function showCategories(v) { return root.dataset.source === 'selected' ? runSelected(v) : runAll(v); }
    function finishCategories(status, v, categories, products) {
      status.innerHTML = '';
      if (categories) {
        status.textContent = 'Категории с ' + label + ' за ' + vehicleText(v) + ':';
      } else {
        status.textContent = 'Все още нямаме ' + label + ' за ' + vehicleText(v) + '. ';
        var c = document.createElement('a');
        c.href = root.dataset.contactUrl || '/pages/contact'; c.className = 'vf__help-link'; c.textContent = 'Пишете ни – ще проверим';
        status.appendChild(c);
      }
      track('vehicle_results', trackParams(v, { results_mode: 'categories', categories_count: categories, products_count: products === undefined ? null : products, has_results: !!categories }));
    }

    root.querySelector('.vf__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v) return;
      store({ make: v.make, model: v.model, gen: v.gen, tag: v.tag });
      track('vehicle_search', trackParams(v, { search_mode: mode }));
      if (mode === 'collection') {
        location.href = filteredUrl(location.pathname + location.search, v.tag);
      } else {
        showSummary('Автомобил: <strong>' + vehicleText(v) + '</strong>', true);
        showCategories(v);
      }
    });
    makeSel.addEventListener('change', onMake);
    modelSel.addEventListener('change', onModel);
    genSel.addEventListener('change', function () { submit.disabled = !current(); });

    loadData(root.dataset.dataUrl).then(function (json) {
      fullData = json;
      data = mode === 'collection' ? restrict(json, availableTags()) : json;
      fill(makeSel, data.map(function (m) { return m.n; }), 'Изберете марка');
      var route = routeOf(location.pathname);
      var fromUrl = route && route.tag ? findByTag(fullData, route.tag) : null;
      if (mode === 'collection' && fromUrl) {
        select(fromUrl);
        var count = parseInt(root.dataset.productsCount || '0', 10);
        if (count > 0) {
          showSummary('Показани са ' + label + ' за <strong>' + vehicleText(fromUrl) + '</strong>', true);
        } else {
          showSummary('В тази категория все още нямаме ' + label + ' за <strong>' + vehicleText(fromUrl) + '</strong>.', true);
          summary.appendChild(emptyHelp(fromUrl));
        }
        track('vehicle_results', trackParams(fromUrl, { results_mode: 'collection', collection: route.prefix.split('/').pop(), products_count: count, has_results: count > 0 }));
        return;
      }
      var saved = stored();
      if (saved && select(saved)) {
        var v = current();
        if (mode === 'categories') { showSummary('Автомобил: <strong>' + vehicleText(v) + '</strong>', true); showCategories(v); }
        else { showSummary('Вашият автомобил: <strong>' + vehicleText(v) + '</strong> — натиснете „' + submit.textContent.trim() + '“', false); }
      } else if (saved && mode === 'collection') {
        var sv = findSaved(fullData, saved);
        if (sv) {
          showSummary('В тази категория все още нямаме ' + label + ' за вашия <strong>' + vehicleText(sv) + '</strong>.', true);
          summary.appendChild(emptyHelp(sv));
        }
      }
    }).catch(function () {
      fill(makeSel, [], 'Търсачката не можа да се зареди');
    });
  }

  // ---- bar under the header: opens the finder in a dialog, shows the saved vehicle
  function initBar(bar) {
    if (!bar || bar.dataset.vfReady) return;
    bar.dataset.vfReady = '1';
    var dialog = bar.querySelector('dialog');
    var openBtn = bar.querySelector('[data-vf-open]');
    var labelEl = bar.querySelector('[data-vf-bar-label]');
    var quick = bar.querySelector('[data-vf-quick]');
    var clearBtn = bar.querySelector('[data-vf-clear]');
    var defaultLabel = labelEl.innerHTML;
    if (clearBtn) clearBtn.addEventListener('click', function () { clearVehicle(); });
    var finder = dialog.querySelector('[data-vf]');

    function render() {
      loadData(finder.dataset.dataUrl).then(function (data) {
        var route = routeOf(location.pathname);
        var active = route && route.tag ? findByTag(data, route.tag) : null;
        var v = active || findSaved(data, stored());
        if (v) {
          labelEl.innerHTML = '';
          var pre = document.createElement('span'); pre.className = 'vf-bar__prefix'; pre.textContent = 'Моят автомобил: ';
          labelEl.appendChild(pre);
          var b = document.createElement('b'); b.textContent = vehicleText(v); labelEl.appendChild(b);
        } else {
          labelEl.innerHTML = defaultLabel;
        }
        if (clearBtn) clearBtn.hidden = !v;
        // on a collection page: one-tap filter for the saved vehicle
        if (quick) {
          var collUrl = bar.dataset.collectionUrl;
          if (collUrl && v && !active) {
            quick.href = filteredUrl(collUrl + location.search, v.tag);
            quick.querySelector('span').textContent = 'Покажи само за ' + v.model + ' ' + genLabel(v.gen).replace(/\s*\(.*\)$/, '');
            quick.hidden = false;
          } else {
            quick.hidden = true;
          }
        }
      }).catch(function () {});
    }
    function open() {
      init(finder);
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('vf-locked');
      var first = dialog.querySelector('select:not([disabled])');
      if (first) setTimeout(function () { first.focus(); }, 50);
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    openBtn.addEventListener('click', open);
    dialog.querySelector('[data-vf-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('vf-locked'); openBtn.focus(); });
    document.addEventListener('vf:change', render);
    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-vf-bar]').forEach(initBar);
    (scope || document).querySelectorAll('[data-vf]').forEach(function (el) {
      if (!el.closest('dialog')) init(el); // finders inside the bar's dialog start when it is opened
    });
  }
  window.VehicleFinder = { init: init, boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
